/**
 * Link
 */
export const GOOGLE_CALENDAR_LINK = `https://calendar.google.com/calendar/event?action=TEMPLATE&dates=20251204T010000Z%2F20251204T080000Z&text=Yayuk+%26+Bayu+Wedding&details=Yayuk+%26+Bayu+Wedding`;
export const GOOGLE_MAPS_LINK = `https://g.co/kgs/Y9eDpH7`;

/**
 * Wedding time
 */
// UNIX timestamp for 2025-12-04T00:00:00Z
export const EPOCH_START_EVENT = 1764806400;
export const EPOCH_END_EVENT = 1764806400;

// UTC string format
export const UTC_WEDDING_TIME = '2025-12-04T00:00:00Z';

